import { getCompanyLogo, getCompanyName } from '@constants/companies';
import Section from '@molecules/Section/Section';
import SectionContent from '@molecules/Section/SectionContent';
import type { CompanyHighlightSection as Props } from '@type-declarations/sections';
import capitalizeFirstLetter from '@utils/capitalizeFirstLetter';
import Image from 'next/legacy/image';

import styles from './CompanyHighlightSection.module.scss';

const companyPlaceholder = '{bedrijf}';

export default function CompanyHighlightSection({
  title,
  text,
  cta,
  image,
  altText,
  companies,
}: Props) {
  const selectedCompany = companies?.trim()?.toLowerCase();
  let titleWithLogo = title;

  if (selectedCompany) {
    const companyLabel =
      getCompanyName(selectedCompany) || capitalizeFirstLetter(selectedCompany);
    const logoPath = getCompanyLogo(selectedCompany);

    if (logoPath && selectedCompany) {
      titleWithLogo = title.replace(
        companyPlaceholder,
        `<img src="${logoPath}" alt="${companyLabel} logo" class="${styles.logoInline}" />`,
      );
    } else if (selectedCompany) {
      titleWithLogo = title.replace(companyPlaceholder, companyLabel);
    }
  }

  return (
    <Section className="u-mb-vertical-spacing">
      <div className={styles.container}>
        <SectionContent
          title={
            // eslint-disable-next-line react/no-danger
            <span dangerouslySetInnerHTML={{ __html: titleWithLogo }} />
          }
          text={text}
          cta={cta}
          ctaVariant="primary"
          icon="arrow-right"
          className={styles.textContent}
        />

        <div className={styles.imageWrapper}>
          <div className={styles.imageContainer}>
            <Image
              src={image.url}
              alt={altText}
              layout="fill"
              placeholder="blur"
              blurDataURL={image.placeholder}
              className={styles.image}
              sizes="(max-width: 768px) 100vw, 1030px"
            />
          </div>
        </div>
      </div>
    </Section>
  );
}
